/**
 *
 *@author xujinjiang
 *@date 2022/3/7 11:00
 */

import { BaseViewModel } from '@/viewmodel/BaseViewModel';
export class PaginationViewModel extends BaseViewModel {
  pageSize = 20;
  pageNo = 1;
  totalCount = 0;
  type = '';

  getList() {
    this.$emit('on-change', { pageNo: this.pageNo, pageSize: this.pageSize });
  }
}
